import { render, staticRenderFns } from "./hot-card.vue?vue&type=template&id=1409fc79&scoped=true&"
import script from "./hot-card.vue?vue&type=script&lang=js&"
export * from "./hot-card.vue?vue&type=script&lang=js&"
import style0 from "./hot-card.vue?vue&type=style&index=0&id=1409fc79&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1409fc79",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {TopicTitle: require('/usr/src/app/components/topic/title.vue').default})
